import { b as e, a as r, c as E, d as L } from "./variables-wAtLeZ-Z.js";
var n = ((a) => (a[a.DEFAULT = parseInt(e, 10)] = "DEFAULT", a[a.MEDIUM = parseInt(r, 10)] = "MEDIUM", a[a.LARGE = parseInt(E, 10)] = "LARGE", a[a.XLARGE = parseInt(L, 10)] = "XLARGE", a))(n || {});
export {
  n as B
};
